const ETAPA_CANCELADO = 'cancelado';

function semEtapaCancelado(opcoes) {
    return (opcoes || []).filter((item) => item.id !== ETAPA_CANCELADO);
}

export default {
    list() {
        const data = (constantes?.ETAPA_OPTIONS || []).slice();
        return Promise.resolve({
            data: {
                data,
                per_page: data.length,
                total: data.length,
            },
        });
    },
    option() {
        return Promise.resolve({
            data: (constantes?.ETAPA_OPTIONS || []).slice(),
        });
    },
    /** Etapas selecionáveis ao criar/editar contrato (cancelado só via módulo Cancelamento). */
    optionParaFormularioContrato() {
        return this.option().then((response) => ({
            data: semEtapaCancelado(response.data),
        }));
    },
}
